// Shared display helpers for shift requests (client Request tab + admin Requests tab).

export const SHIFT_TYPE_LABELS = {
  ANY: 'Any',
  BREAKFAST: 'Breakfast',
  LUNCH: 'Lunch',
  DINNER: 'Dinner',
  RECEPTION: 'Reception',
  COFFEE_BREAK: 'Coffee Break',
  CASH_CONCESSION: 'Cash Concession'
};

// "Dinner", "Any", or "Any except Coffee Break, Reception"
export function fmtShiftType(r) {
  const label = SHIFT_TYPE_LABELS[r.shiftType] || r.shiftType;
  const ex = r.shiftType === 'ANY' ? (r.excludeTypes || []) : [];
  return ex.length ? `${label} except ${ex.map(t => SHIFT_TYPE_LABELS[t] || t).join(', ')}` : label;
}

// 1630 -> "4:30 PM"; null -> ''
export function fmtHHMM(n) {
  if (n == null) return '';
  const h = Math.floor(n / 100), m = n % 100;
  const h12 = h % 12 || 12;
  return `${h12}:${String(m).padStart(2, '0')} ${h < 12 ? 'AM' : 'PM'}`;
}

// 1630 -> "16:30" for <input type="time">
export function toTimeInput(n) {
  if (n == null) return '';
  return `${String(Math.floor(n / 100)).padStart(2, '0')}:${String(n % 100).padStart(2, '0')}`;
}

// "2026-10-05" -> "Mon 10/5/2026"
export function fmtRequestDate(d) {
  if (!d) return '';
  const [y, m, day] = d.split('-').map(Number);
  const wd = new Date(Date.UTC(y, m - 1, day)).toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' });
  return `${wd} ${m}/${day}/${y}`;
}

export function fmtTimeRange(r) {
  if (r.tmstart == null && r.tmend == null) return 'Any time';
  if (r.tmend == null) return `From ${fmtHHMM(r.tmstart)}`;
  if (r.tmstart == null) return `Until ${fmtHHMM(r.tmend)}`;
  return `${fmtHHMM(r.tmstart)} – ${fmtHHMM(r.tmend)}`;
}

export function todayPacific() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Los_Angeles' });
}
